// extracted by mini-css-extract-plugin
export var tosLink = "_dw-0";